export default "__VITE_ASSET__BGtNh2oQ__"